"use client";

import { useEffect } from "react";
import { isDocumentDefined } from "@huub-web/utils";

import type { RefTypes } from "../types";

export function useClickOutside<T extends HTMLElement>(
  refs: RefTypes<T>,
  onOutsideClick: () => void,
): void {
  useEffect(() => {
    if (!isDocumentDefined()) {
      return;
    }

    const refArray = Array.isArray(refs) ? refs : [refs];

    const handleClickOutside = (event: MouseEvent) => {
      let isInside = false;

      refArray.forEach((ref) => {
        let isInsideElement = false;

        if (
          ref &&
          "current" in ref &&
          ref.current &&
          (ref.current.contains(event.target as Node) ||
            event.target === ref.current)
        ) {
          isInsideElement = true;
          // console.log("->", isInsideElement ? "✅" : "❌", ref.current);
        } else if (
          ref instanceof HTMLElement &&
          ref.contains(event.target as Node)
        ) {
          isInsideElement = true;
          // console.log("->", isInsideElement ? "✅" : "❌", ref);
        }

        if (isInside === false && isInsideElement) {
          isInside = true;
        }
      });

      if (!isInside) {
        onOutsideClick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, onOutsideClick]);
}
